import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const ShoppingFilter = ({
  brandName,
  onCategoryChange,
  onBrandChange,
  selectedCategory = "all",
  selectedBrand = null,
}) => {
  const location = useLocation();
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState(selectedCategory);
  const [brands, setBrands] = useState([]);
  const [brandsData, setBrandsData] = useState([]);
  const [showAllBrands, setShowAllBrands] = useState(false);

  const filterProducts = (products, categories, filter) => {
    return products.filter((product) => {
      if (filter === "all") return true;
      const category = categories.find((cat) => cat.id === product.category_id);
      return category && category.class === filter;
    });
  };

  const filterBrands = (products, categories, filter) => {
    return products.filter((product) => {
      if (filter === "all") return true;
      const category = categories.find((cat) => cat.id === product.category_id);
      return category && category.class === filter;
    });
  };

  const findBrands = (classType) => {
    if (classType === "all") {
      let brandsArr = [];
      for (let i = 0; i < categories.length; i++) {
        brandsArr = [...brandsArr, ...categories[i].brands];
      }
      setBrands([...new Set(brandsArr)]);
    } else {
      const category = categories.find((cat) => cat.class === classType);
      setBrands(category.brands);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/products.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setCategories(data.categories);
        setProducts(data.products);
        setBrandsData(data.brands);
        console.log(data.brands);

        // Check for category parameter in URL
        const urlParams = new URLSearchParams(location.search);
        const categoryParam = urlParams.get("category");

        if (categoryParam) {
          const categoryId = parseInt(categoryParam);
          const category = data.categories.find((cat) => cat.id === categoryId);
          if (category) {
            setFilter(category.class);
            setBrands(category.brands);
            return;
          }
        }

        // Default: show all brands
        let brandsArr = [];
        for (let i = 0; i < data.categories.length; i++) {
          brandsArr = [...brandsArr, ...data.categories[i].brands];
        }
        setBrands([...new Set(brandsArr)]);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchData();
  }, [location.search]);

  const filteredProducts = filterProducts(products, categories, filter);

  return (
    <div className="filter-container">
      {/* Clear Filters Button */}
      <button
        className="clear-filters-btn"
        onClick={() => {
          setFilter("all");
          findBrands("all");
          onCategoryChange && onCategoryChange("all");
          onBrandChange && onBrandChange(null);
        }}
      >
        Clear All Filters
      </button>

      {/* Brands Filter */}
      <div className="filter-section">
        <h4 className="filter-title">Brands</h4>
        <div className="filter-list">
          {brands
            .slice(0, showAllBrands ? brands.length : 10)
            .map((brand, i) => {
              const brandData = brandsData.find((b) => b.id === brand);
              if (!brandData) return null;

              return (
                <button
                  key={i}
                  className={`filter-item ${
                    selectedBrand === brandData.id ? "active" : ""
                  }`}
                  onClick={() => {
                    const newSelectedBrand =
                      selectedBrand === brandData.id ? null : brandData.id;
                    onBrandChange && onBrandChange(newSelectedBrand);
                  }}
                >
                  <img
                    src={`/images/brands/${brandData.name}.png`}
                    alt={brandData.name}
                    className="brand-logo-tiny"
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                  {brandData.name}
                </button>
              );
            })}
          {brands.length > 10 && (
            <button
              className="brands-more-btn"
              onClick={() => setShowAllBrands(!showAllBrands)}
            >
              <span className="brands-more-text">
                {showAllBrands
                  ? "Show Less"
                  : `+${brands.length - 10} more brands`}
              </span>
            </button>
          )}
        </div>
      </div>

      {/* Categories Filter */}
      <div className="filter-section">
        <h4 className="filter-title">Categories</h4>
        <div className="filter-list">
          <button
            className={`filter-item ${filter === "all" ? "active" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              setFilter("all");
              findBrands("all");
              onCategoryChange && onCategoryChange("all");
            }}
          >
            All Categories
          </button>
          {categories.map((category, i) => (
            <button
              key={i}
              className={`filter-item ${
                filter === category.class ? "active" : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                setFilter(category.class);
                findBrands(category.class);
                onCategoryChange && onCategoryChange(category.class);
              }}
            >
              {category.name.charAt(0).toUpperCase() +
                category.name.replace(/ - /g, "/").slice(1)}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

// The filterProducts function can be imported or defined above this component.
export default ShoppingFilter;
